import { BookOpen } from "lucide-react";
import { Button } from "@web/components/ui/button";

export function ReaderEmptyState({ onReturn }: { onReturn: () => void }) {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <section className="w-full max-w-md border bg-background p-6">
        <h1 className="flex items-center gap-2 font-semibold">
          <BookOpen className="size-4" />
          阅读
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">从书架或搜索结果打开一本书后进入阅读工作台</p>
        <p className="mt-6 border border-dashed px-4 py-6 text-center text-sm text-muted-foreground">当前没有打开章节</p>
        <Button className="mt-4 w-full" variant="secondary" onClick={onReturn}>
          回到书架
        </Button>
      </section>
    </div>
  );
}
